import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

const articleData = [
  {
    id: 'article-1',
    image: 'https://readdy.ai/api/search-image?query=Summer%20movie%20theater%20atmosphere%20with%20film%20projector%20and%20popcorn%2C%20warm%20golden%20tones%2C%20cozy%20cinema%20vibe%2C%20artistic%20minimal%20style%2C%20soft%20lighting&width=600&height=400&seq=popular-movie-01&orientation=landscape',
  },
  {
    id: 'article-2',
    image: 'https://readdy.ai/api/search-image?query=Smartphone%20playing%20video%20on%20minimal%20desk%20with%20headphones%2C%20warm%20ambient%20lighting%2C%20modern%20clean%20aesthetic%2C%20soft%20shadows&width=600&height=400&seq=popular-phone-01&orientation=landscape',
  },
  {
    id: 'article-4',
    image: 'https://readdy.ai/api/search-image?query=TV%20series%20drama%20collage%20with%20warm%20cinematic%20lighting%2C%20modern%20living%20room%2C%20artistic%20minimal%20style%2C%20cozy%20evening%20vibe&width=600&height=400&seq=popular-tv-01&orientation=landscape',
  },
  {
    id: 'article-5',
    image: 'https://readdy.ai/api/search-image?query=Variety%20show%20stage%20with%20colorful%20lights%20and%20laughter%2C%20vibrant%20warm%20atmosphere%2C%20artistic%20composition%2C%20soft%20glowing%20effect&width=600&height=400&seq=popular-variety-01&orientation=landscape',
  },
];

const imageMap: Record<string, string> = {};
articleData.forEach((item) => { imageMap[item.id] = item.image; });

const PopularSection = () => {
  const popularArticles = articles.filter((a) => imageMap[a.id]).slice(0, 4);

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-14 gap-4">
          <div>
            <span className="inline-block px-4 py-1.5 bg-primary-100 text-primary-700 rounded-full text-xs font-medium mb-4">
              热门推荐
            </span>
            <h2 className="text-2xl md:text-4xl font-heading text-foreground-950">
              大家都在
              <span className="text-primary-500">在线观看</span>
            </h2>
          </div>
          <Link
            to="/category/dianying"
            className="flex items-center gap-1 text-primary-500 text-sm font-medium hover:text-primary-600 transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {popularArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/40 transition-all duration-300 hover:-translate-y-1 no-underline"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={imageMap[article.id]}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 m-3">
                  <span className="px-2.5 py-1 bg-primary-500 text-background-50 rounded-full text-xs font-medium">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm font-medium text-foreground-950 line-clamp-2 mb-2 group-hover:text-primary-500 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 line-clamp-2 mb-3 leading-relaxed">{article.excerpt}</p>
                <div className="flex items-center justify-between text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.views.toLocaleString()}
                  </span>
                  <span>{article.readTime}阅读</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PopularSection;